import { Component, OnInit } from '@angular/core';
import { VersionUpateService } from '@services/version-update/version-update.service';
import { AnalyticsService } from '@services/analytics/analytics.service';
import { GoogleSearchDispatch } from '@state/google-search/google-search.dispatch';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false,
})
export class AppComponent implements OnInit {
	ngOnInit(): void {
		this.googleSearchDispatch.GoogleSearchConnect();
		this.analyticsService.trackPwaUsage();
	}

	constructor(
		private googleSearchDispatch: GoogleSearchDispatch,
		private analyticsService: AnalyticsService,
		// Don't remove this Service, constructor fire functionality
		private versionUpdateService: VersionUpateService,
	) {}

	sendRequest() {
		console.log('sendRequest for funds');
	}
}
